export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-flag-2454c049a5b2aea1b986438ce8c782f0.svg";